import { render } from "./StyledTab.vue?vue&type=template&id=c9ee24f8"
import script from "./StyledTab.vue?vue&type=script&lang=js"
export * from "./StyledTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__